export default function ErrorPage({
  title = "Whoops!",
  description = "Something went wrong",
}: {
  title?: string;
  description?: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center w-screen h-screen px-4 py-8 text-center">
      <h2 className="mb-6 text-5xl font-semibold">{title}</h2>
      <h3 className="mb-1.5 text-3xl font-semibold">{description}</h3>
    </div>
  );
}
